import { render, staticRenderFns } from "./Oxylvl.vue?vue&type=template&id=379c910d&"
import script from "./Oxylvl.vue?vue&type=script&lang=js&"
export * from "./Oxylvl.vue?vue&type=script&lang=js&"
import style0 from "./Oxylvl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports